import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { compact } from 'lodash'

import { translate, utils } from 'parking-react-common'

import Panel from '../components/Panel'
import InfoTable from '../components/InfoTable'
import { Column } from '../components/Grid'
import WeeklyTimetable from '../components/WeeklyTimetable'
import FixedDurationsList from '../components/FixedDurationsList'
import SpecialIntervalsList from '../components/SpecialIntervalsList'

import { parkingLots } from '../redux'

const ScheduleDetails = ({ item, t }) => {
    if (!item) {
        return null
    }

    const { schedule } = item
    const hasFixedDurations = parkingLots.hasFixedDurations(item)

    const scheduleDetails = compact([
        {
            title : t('Currency'),
            value : item.currency
        },
        {
            title : t('Pay Before'),
            value : utils.humanizeBoolean(item.pay_before)
        },
        {
            title : t('Fixed Price Intervals'),
            value : utils.humanizeBoolean(hasFixedDurations)
        },
        {
            title : t('Schedule Type'),
            value : parkingLots.getScheduleName(schedule)
        },
        !hasFixedDurations && {
            title : t('Price'),
            value : utils.formatAmountWithUnit(item.singlePrice, item.currency)
        }
    ])

    const limitations = compact([
        {
            title : t('Minimum Stay'),
            value : utils.humanizeTime(item.min_time)
        },
        {
            title : t('Maximum Stay'),
            value : utils.humanizeTime(item.max_time)
        },
        {
            title : t('Minimum Cost'),
            value : utils.formatAmountWithUnit(item.min_cost, item.currency)
        },
        {
            title : t('Maximum Cost'),
            value : utils.formatAmountWithUnit(item.max_cost, item.currency)
        }
    ])

    return (
        <Fragment>
            <Panel title={ t('Schedule and Pricing') } hasTable withDivider>
                <Column span={ 6 }>
                    <InfoTable data={ scheduleDetails } />
                </Column>
            </Panel>
            { hasFixedDurations && <FixedDurationsList item={ item } /> }
            { schedule !== parkingLots.SCHEDULE_TYPES.alwaysOpen && <WeeklyTimetable item={ item } /> }
            <SpecialIntervalsList item={ item } />
            <Panel title={ t('Limitations') } hasTable withDivider>
                <Column span={ 6 }>
                    <InfoTable data={ limitations } />
                </Column>
            </Panel>
        </Fragment>
    )
}

ScheduleDetails.propTypes = {
    item: PropTypes.object
}

export default translate()(ScheduleDetails)
